<template>
  <v-form class="pa-3" ref="gatewaySettingForm">
    <div v-if="user_role == DEFINES.USER_ROLE_SUPER_ADMIN">
      <h3>List of Enabled Payment Gateways</h3>
      <v-checkbox
        :v-if="gateways"
        v-for="(gateway, index) in gateways"
        multiple
        :id="gateway.value"
        v-model="company.payment_setting.enabled_payment_gateways"
        :key="index"
        :value="gateway.value"
        :label="gateway.title"
        @change="check($event)"
      />
      <div v-if="showMeshulamConfig">
        <div class="greyDarken2--text">
          <h3>
            <span class="greyDarken3--text"
              >Meshulam Payment Gateway Configuration</span
            >
          </h3>
          <h5>
            <span class="greyDarken3--text body-1">
              The below configutations are optional. If you will leave them
              blank then by default superadmin's meshulam account credentials
              will be used. <br />Set the current company's meshulam account
              credentials only if the company wants to get the payment directly
              to their meshulam account
            </span>
          </h5>
        </div>
        <v-text-field
          v-model="company.payment_setting.meshulam.userId"
          class="mb-3"
          color="primary"
          type="text"
          label="userId"
        ></v-text-field>
        <v-text-field
          v-model="company.payment_setting.meshulam.bitPageCode"
          v-if="showMeshulamConfig"
          class="mb-3"
          color="primary"
          type="text"
          label="Page Code for Bit"
        ></v-text-field>
        <v-text-field
          v-model="company.payment_setting.meshulam.creditPageCode"
          v-if="showMeshulamConfig"
          class="mb-3"
          color="primary"
          type="text"
          label="Page Code for Credit Card"
        ></v-text-field>
        <v-divider class="mt-1 mb-3"></v-divider>
      </div>
    </div>
    <div class="greyDarken2--text">
      <v-tooltip top color="white">
        <template v-slot:activator="{on}">
          <v-img
            v-on="on"
            class="white--text d-inline-block"
            width="4%"
            :src="
              'https://jungleworks.com/wp-content/uploads/2020/02/stripe-logo-icon.png'
            "
          ></v-img>
        </template>
        <span class="greyDarken3--text body-1">Stripe Payment Gateway</span>
      </v-tooltip>
    </div>
    <v-divider class="mt-1 mb-3"></v-divider>
    <v-text-field
      :value="company.payment_setting.stripe.statement_descriptor_suffix"
      @input="toUpperCaseDescriptors('statement_descriptor_suffix', $event)"
      class="mb-3"
      color="primary"
      type="text"
      :rules="[
        rules.required,
        rules.min_length(2),
        rules.max_length(10),
        rules.paymentDescriptor,
      ]"
      :label="$t('screener.payment_setting.statement_descriptor_suffix.label')"
      persistent-hint
      :hint="$t('screener.payment_setting.statement_descriptor_suffix.hint')"
    ></v-text-field>
    <div
      class="mb-3"
      v-if="company.payment_setting.stripe.statement_descriptor_suffix"
    >
      <span class="greyDarken2--text">Calculated Statement Descriptor : </span>
      <span>
        <b
          >{{ DEFINES.PAYMENT_GATEWAYS.STRIPE.statement_descriptor }}&nbsp;{{
            company.payment_setting.stripe.statement_descriptor_suffix
          }}</b
        >
      </span>
    </div>
    <div class="greyDarken2--text">
      For more detail about descriptors,
      <a
        href="https://stripe.com/docs/statement-descriptors"
        target="_blank"
        rel="noopener noreferrer"
        >Click Here</a
      >
    </div>
    <v-divider class="mt-1 mb-3"></v-divider>
    <v-switch
      v-model="company.payment_setting.stripe.secure_3d"
      :label="$t('screener.save.form.stripe.3d_secure')"
      color="saPrimary"
      value="true"
    ></v-switch>

  </v-form>
</template>

<script>
import rules from '@/validation';
import {mapState} from 'vuex';

export default {
  name: 'PaymentGatewaySetting',
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rules,
      gateways: null,
      showMeshulamConfig: false,
      meshulam_default_settings: {
        userId: null,
        creditPageCode: null,
        bitPageCode: null,
      },
    };
  },
  watch: {
    company: {
      deep: true,
      handler: function() {
        this.$emit('update:company', this.company);
      },
    },
  },
  computed: {
    ...mapState({
      user_role: (state) => state.user.profile.role,
    }),
  },
  mounted() {
    this.getPaymentGatewayList();
    this.initialisePaymentGatewaySettings();
  },
  methods: {
    initialisePaymentGatewaySettings() {
      this.checkForMeshulamConfig(
        this.company.payment_setting.enabled_payment_gateways
      );
    },

    checkForMeshulamConfig(inputArray) {
      if (!inputArray || inputArray.length == 0) {
        return;
      }

      this.showMeshulamConfig = false;
      if (inputArray.indexOf('meshulam') !== -1) {
        this.showMeshulamConfig = true;
      }

      if (
        this.company.payment_setting.meshulam &&
        Object.keys(this.company.payment_setting.meshulam).length > 0
      ) {
        return;
      }

      if (
        inputArray.indexOf('meshulam') !== -1 ||
        inputArray.indexOf('bit') !== -1
      ) {
        this.company.payment_setting.meshulam = this.meshulam_default_settings;
      }
    },

    check: function(e) {
      this.checkForMeshulamConfig(e);
    },

    async getPaymentGatewayList() {
      try {
        var response = await this.$store.dispatch(
          'company/listPaymentGateways',
          {
            company_id: this.company.id,
          }
        );
        this.gateways = response.gateways;
        var _this = this;
        if (
          !this.company.payment_setting.enabled_payment_gateways ||
          this.company.payment_setting.enabled_payment_gateways.length == 0
        ) {
          this.company.payment_setting.enabled_payment_gateways = [];

          Object.keys(this.gateways).forEach(function(key) {
            if (_this.gateways[key]['is_enabled'] === true) {
              _this.company.payment_setting.enabled_payment_gateways.push(
                _this.gateways[key].value
              );
            }
          });
        }
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },

    toUpperCaseDescriptors(property, value) {
      if (!value) {
        this.company.payment_setting.stripe[property] = value;
        return;
      }
      this.company.payment_setting.stripe[property] = value.toUpperCase();
    },
    validate() {
      return this.$refs.gatewaySettingForm.validate();
    },
  },
};
</script>

<style></style>
